var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"banner text-center",attrs:{"height":"120px","width":"100%","color":"accent"}},[_c('h1',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.text))]),_c('h3',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }